import script from "./FilterSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterSection.vue?vue&type=script&setup=true&lang=js"

import "./FilterSection.vue?vue&type=style&index=0&id=336c55b7&scoped=true&lang=scss"

import exportComponent from "/builds/smartdevops/viccarbe/viccarbe-professional-area/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-336c55b7"]])

export default __exports__